import { ResourceField } from '@scalingworks/refine-react-admin';
import { Membership } from '~/api';

export const getMembershipFields: ResourceField<Membership>[] = [
  'id',
  'firstName',
  'lastName',
  'pointEarned',
  'pointBalance',
  'pointRequired',
  'periodEndAt',
  'pointValidUntil',
  {
    tierProgress: [
      'description',
      'pointToNextTier',
      'isHighestTier',
      { currentTier: ['id', 'name'] },
      { nextTier: ['id', 'name'] },
    ],
  },
] as ResourceField<Membership>[];
